import "./FormField.scss";
function FormField({
  type,
  id,
  value,
  placeholder,
  onChange,
  c,
  r,
  onFocus,
  onBlur,
  onClick,
  disabled,
  max,
}) {
  return (
    <div className={`form-group`}>
      {c > 0 && r > 0 ? (
        <textarea
          className="form-field"
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onClick}
          placeholder={placeholder}
          disabled={disabled}
          max={max}
          cols={c}
          rows={r}
        />
      ) : (
        <input
          className="form-field"
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onClick={onClick}
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled}
          style={
            disabled
              ? {
                  backgroundColor: "#f0f0f0",
                  color: "#a0a0a0",
                  cursor: "not-allowed",
                }
              : {}
          }
          max={max}
        />
      )}
    </div>
  );
}

export default FormField;
